import { useContext } from "react";
import { AddTaskMenuItemContext } from "./AddTaskMenuItemContext.tsx";

export const useAddTaskMenuItem = () => {
    return useContext(AddTaskMenuItemContext);
};
